module.exports = __webpack_public_path__ + "static/ai-2-e6958fefbcb30b8ff2651ab698a89b44.png";